/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiJobSubmitResponseItem
 */
export interface ApiJobSubmitResponseItem {
    /**
     * 
     * @type {string}
     * @memberof ApiJobSubmitResponseItem
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiJobSubmitResponseItem
     */
    jobId?: string;
}

export function ApiJobSubmitResponseItemFromJSON(json: any): ApiJobSubmitResponseItem {
    return ApiJobSubmitResponseItemFromJSONTyped(json, false);
}

export function ApiJobSubmitResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiJobSubmitResponseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : json['error'],
        'jobId': !exists(json, 'jobId') ? undefined : json['jobId'],
    };
}

export function ApiJobSubmitResponseItemToJSON(value?: ApiJobSubmitResponseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': value.error,
        'jobId': value.jobId,
    };
}

